<template>
  <div class="d-flex justify-content-center">
    <div class="row justify-content-center w-100">
      <div
        class="text-center"
        :class="
          isMobile && isMobile === 'mobile' ? 'mt-4' : 'col-6 m-5 p-4 w-75'
        "
      >
        <h2 class="h4">
          {{ error.name }}
        </h2>
        <h4>
          {{ error.message }}
        </h4>
        <p v-if="error.name === 'Error'">
          Please wait a few seconds then
          <a :href="refreshUrl">refresh this page</a>.
          <br />
          If the problem persists,
          <a :href="'/' + county.slug">try a different search</a>.
        </p>
        <p v-else>
          <a
            class="text-nowrap fs-4"
            data-bs-target="#search-tips-modal"
            data-bs-toggle="modal"
            href="#"
            >Click for search tips!</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      refreshUrl: window.location.search,
    };
  },
  props: {
    error: {
      type: Error,
      required: true,
    },
    county: {
      type: Object,
      required: true,
    },
    isMobile: {
      // mobile|desktop
      type: String,
      required: false,
    },
  },
});
</script>
